import React, { useRef, useState, useEffect } from "react";
import { Stage, Layer, Rect, Text, Image, Transformer } from "react-konva";

export default function AdminBillFormates() {
  const [elements, setElements] = useState([]);
  const stageRef = useRef(null);
  const transformerRef = useRef(null);
  const [selectedId, setSelectedId] = useState(null);

  const addText = () => {
    setElements([
      ...elements,
      {
        id: `text-${elements.length}`,
        type: "text",
        x: 50,
        y: 50,
        text: "Sample Text",
        fontSize: 16,
        fontStyle: "normal",
        fontFamily: "Arial",
      },
    ]);
  };

  const handleDrag = (id, e) => {
    const newElements = elements.map((el) =>
      el.id === id ? { ...el, x: e.target.x(), y: e.target.y() } : el
    );
    setElements(newElements);
  };

  const handleTransform = (id, node) => {
    const newElements = elements.map((el) =>
      el.id === id
        ? {
            ...el,
            x: node.x(),
            y: node.y(),
            fontSize: node.fontSize(),
          }
        : el
    );
    setElements(newElements);
  };

  const updateTextProperty = (property, value) => {
    const updatedElements = elements.map((el) =>
      el.id === selectedId ? { ...el, [property]: value } : el
    );
    setElements(updatedElements);
  };

  const exportTemplate = () => {
    const json = JSON.stringify(elements, null, 2);
    console.log(json);
    alert("Template exported! Check console for JSON.");
  };

  return (
    <div>
      <div style={{ marginBottom: "10px" }}>
        <button onClick={addText}>Add Text</button>
        <button onClick={exportTemplate}>Export Template</button>
      </div>

      {selectedId && (
        <div style={{ marginBottom: "10px" }}>
          <label>
            Font Size:
            <input
              type="number"
              value={
                elements.find((el) => el.id === selectedId)?.fontSize || 16
              }
              onChange={(e) =>
                updateTextProperty("fontSize", parseInt(e.target.value, 10))
              }
            />
          </label>
          <label>
            Font Style:
            <select
              value={
                elements.find((el) => el.id === selectedId)?.fontStyle ||
                "normal"
              }
              onChange={(e) => updateTextProperty("fontStyle", e.target.value)}
            >
              <option value="normal">Normal</option>
              <option value="bold">Bold</option>
            </select>
          </label>
          <label>
            Font Family:
            <select
              value={
                elements.find((el) => el.id === selectedId)?.fontFamily ||
                "Arial"
              }
              onChange={(e) => updateTextProperty("fontFamily", e.target.value)}
            >
              <option value="Arial">Arial</option>
              <option value="Verdana">Verdana</option>
              <option value="Times New Roman">Times New Roman</option>
              <option value="Courier New">Courier New</option>
            </select>
          </label>
          <label>
            X-Axis:
            <input
              type="number"
              value={elements.find((el) => el.id === selectedId)?.x || 0}
              onChange={(e) =>
                updateTextProperty("x", parseInt(e.target.value, 10))
              }
            />
          </label>
          <label>
            Y-Axis:
            <input
              type="number"
              value={elements.find((el) => el.id === selectedId)?.y || 0}
              onChange={(e) =>
                updateTextProperty("y", parseInt(e.target.value, 10))
              }
            />
          </label>
        </div>
      )}

      <Stage
        width={800}
        height={600}
        style={{ border: "1px solid black" }}
        ref={stageRef}
        onMouseDown={(e) => {
          const clickedOn = e.target.attrs.id;
          setSelectedId(clickedOn || null);
        }}
      >
        <Layer>
          {elements.map((el) => {
            if (el.type === "text") {
              return (
                <Text
                  key={el.id}
                  id={el.id}
                  x={el.x}
                  y={el.y}
                  text={el.text}
                  fontSize={el.fontSize}
                  fontStyle={el.fontStyle}
                  fontFamily={el.fontFamily}
                  draggable
                  onDragEnd={(e) => handleDrag(el.id, e)}
                  onClick={() => setSelectedId(el.id)}
                />
              );
            }
            return null;
          })}
          <Transformer
            ref={transformerRef}
            boundBoxFunc={(oldBox, newBox) => {
              if (newBox.width < 20 || newBox.height < 20) {
                return oldBox;
              }
              return newBox;
            }}
          />
        </Layer>
      </Stage>
    </div>
  );
}
